import React from 'react';
import { Paragraph } from '../../../../../../core';
import { DateTimeFilter } from '../../../../../../api/models';
import { DateUtility } from '@mchs/web-core';

export interface NoSimilarProvidersProps {
  filter: DateTimeFilter;
}

const NoSimilarProviders: React.FC<NoSimilarProvidersProps> = (
  props: NoSimilarProvidersProps
) => {
  return (
    <Paragraph
      text={`There are no similar care providers available from ${
        props.filter.date
          ? DateUtility.formatDateLongMonth(props.filter.date)
          : ''
      } - ${
        props.filter.thruDate
          ? DateUtility.formatDateLongMonth(props.filter.thruDate)
          : ''
      }`}
    />
  );
};

export default NoSimilarProviders;
